module.exports = __webpack_public_path__ + "rotate-ccw.svg";